import loadable from '@loadable/component';

const ReactMoment = loadable(() =>
  import(/* webpackChunkName: "ReactMoment" */ 'react-moment'),
);

export default ReactMoment;
